import React, { ReactNode } from 'react';
import { ColorType } from '../../../editor/features/beta/styles/colorsByType';
import { isFacebookConnectedSelector } from '@mm/state/selectors/userSelector';
import { useSelector } from 'react-redux';
import { ErrorTooltip } from '../ErrorTooltip/ErrorTooltip';
import { Link } from '@mm/components';
import { SETTINGS_ADVERTISING } from '../../constants/routes';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';

type Props = {
  validation?: string[];
  classPrefix: string;
  position?: 'top' | 'bottom';
  align?: 'start' | 'end' | 'center';
  customIcon?: ReactNode;
  customMessage?: ReactNode;
  type?: ColorType;
  hoverMode?: boolean;
  hasAccounts?: boolean;
};

export const AccountErrorTooltip = (props: Props) => {
  const { hasAccounts, ...tooltipProps } = props;
  const { validation, classPrefix } = tooltipProps;
  const isFacebookConnected = useSelector(isFacebookConnectedSelector);
  const botId = useSelector(activeChatbotIdSelector);
  if (hasAccounts || isFacebookConnected) {
    return <ErrorTooltip {...tooltipProps} />;
  }
  return (
    <ErrorTooltip
      {...tooltipProps}
      customMessage={
        <ul className={`${classPrefix}__validation-messages`}>
          {(validation || []).map((message, index) => (
            <li className={`${classPrefix}__validation-message`} key={index}>
              {message}
            </li>
          ))}
          <li className={`${classPrefix}__validation-message`}>
            <span>
              No FB ad accounts available. Please have an owner or admin select
              an FB ad account under
            </span>{' '}
            <Link
              className={`${classPrefix}__validation-link`}
              href={`${location.origin}${SETTINGS_ADVERTISING(botId)}`}
            >
              Settings {'>'} Advertising
            </Link>
          </li>
        </ul>
      }
    />
  );
};
